module.exports = __webpack_public_path__ + "static/media/th-list.51dca9cc.svg";